import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DoctorProfile } from '@cureskin/api-client-rn';
import { AppConfig } from 'client/app/app.config';

@Component({
  selector: 'doctor-reply',
  templateUrl: './doctor-reply.html',
  styleUrls: ['../../../user/user-view/user-home/user-home.scss'],
  standalone: false,
})
export class DoctorReplyComponent implements OnInit {
  @Input('userDoctor') userDoctor: DoctorProfile;
  @Output('viewTicket') viewTicket: EventEmitter<any> = new EventEmitter();
  constructor(
    public appConfig: AppConfig,
  ) { }

  ngOnInit(): void {
  }

  handleClick(): void {
    this.viewTicket.emit();
  }
}
